import { render } from "./CategorySavePartial.vue?vue&type=template&id=1075d71d"
import script from "./CategorySavePartial.vue?vue&type=script&lang=js"
export * from "./CategorySavePartial.vue?vue&type=script&lang=js"
script.render = render

export default script